'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _MinusSquareOutlined = _interopRequireDefault(require('./lib/icons/MinusSquareOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _MinusSquareOutlined;
exports.default = _default;
module.exports = _default;